<fa-icon [icon]="faSpinner" [spin]="options.isSpinning" [size]="options.size"
         [ngClass]="{'text-secondary': options.classSecondary, 'text-primary': options.classPrimary}"></fa-icon>
